import { rememberView } from '../ui/subViewRoutes';

/**
 * KAN-518: land on Por facturar (Cobrar) already searching for ONE customer.
 * Cobrar's search is local state, so the hand-off is a one-shot in-memory seed
 * the segment reads when it mounts — the customer's name never enters a URL
 * (AGENTS: free-text search/names are NEVER in a URL). Cleared on sign-out by
 * clearCobrarSearchSeed (wired next to clearRememberedViews).
 */
let seed = '';
const listeners = new Set();

/** A Cobrar segment that is ALREADY mounted (kept warm) takes the seed live. */
export function subscribeCobrarSearchSeed(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function seedCobrarSearch(name) {
  seed = String(name || '').trim();
  if (!seed) return;
  listeners.forEach((fn) => { try { fn(); } catch { /* one listener never breaks the hand-off */ } });
}

/** Read without clearing — for a useState initializer (StrictMode runs it twice). */
export function peekCobrarSearchSeed() {
  return seed;
}

/** Read-and-clear: only the first Cobrar mount after the hand-off consumes it. */
export function takeCobrarSearchSeed() {
  const out = seed;
  seed = '';
  return out;
}

export function clearCobrarSearchSeed() {
  seed = '';
}

/** Navigate: remember the Cobrar sub-view, seed the search, switch to the invoices tab. */
export function openCobrarForCustomer(navigateToTab, customerName) {
  rememberView('app/invoices', 'cobrar');
  seedCobrarSearch(customerName);
  navigateToTab('invoices');
}
